import React from 'react';
import { Card } from 'antd';
import { useIntl } from 'react-intl';
import { EnvironmentOutlined } from '@ant-design/icons';
import { isEmpty, isNil } from 'lodash';

interface GoogleMapMockupProps {
    mapUrl?: string;
    height?: number | string;
}

const GoogleMap: React.FC<GoogleMapMockupProps> = ({
    mapUrl,
    height = 400
}) => {
    const intl = useIntl();

    if(isNil(mapUrl) || isEmpty(mapUrl)) return

    return (
        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <EnvironmentOutlined style={{ color: '#ff4d4f', fontSize: 18 }} />
                    <span>{intl.formatMessage({ id: 'hotel.map', defaultMessage: 'แผนที่โรงแรม' })}</span>
                </div>
            }
            styles={{
                root: {
                    borderRadius: 16,
                    border: 'none',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                    overflow: 'hidden'
                },
                body: { padding: 0 }
            }}
        >
            <iframe
                title="Hotel Map"
                width="100%"
                height={typeof height === 'number' ? `${height}px` : height}
                src={mapUrl}
                allowFullScreen
                style={{ border: 0, display: 'block' }}
                loading="lazy"
            />
        </Card>
    );
};

export default GoogleMap;